import React from "react";
import PropTypes from "prop-types";

const readChecked = (checked, value) => {
  if (value !== undefined) {
    return value + "" === "true" || value === "on";
  }
  return checked ?? false;
};

const CFToggle = ({
  name,
  checked = false,
  value,
  onChange,
  onBlur,
  onFocus,
  disabled = false,
  className = "",
}) => {
  const isChecked = readChecked(checked, value);

  const handleChange = (e) => {
    onChange?.(e.target.checked, e);
  };

  const handleBlur = (e) => {
    onBlur?.(e.target.checked);
  };

  const handleFocus = (e) => {
    onFocus?.(e.target.checked);
  };

  return (
    <label
      className={className}
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      <input
        type="checkbox"
        name={name}
        className="ios-switch green"
        style={{ display: "none" }}
        checked={isChecked}
        disabled={disabled}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
      />
      <article>
        <article></article>
      </article>
    </label>
  );
};

CFToggle.propTypes = {
  name: PropTypes.string,
  checked: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default CFToggle;
